import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CtxForm } from '../../../_forms/models/form.model';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthnService } from '../../../_services/authn.service';
import { Router } from '@angular/router';
import { CtxButtonComponent } from '../../button/button.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CtxAlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'ctx-customer-two-factor-login',
  templateUrl: './customer-two-factor-login.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CtxAlertComponent,
    MatFormFieldModule,
    MatInputModule,
    CtxButtonComponent,
  ],
})
export class CustomerTwoFactorLoginComponent
  extends CtxForm
  implements OnInit, AfterViewInit
{
  constructor(
    private fb: FormBuilder,
    public authnService: AuthnService,
    private router: Router
  ) {
    super();
  }

  @ViewChild('input') inputElement!: ElementRef;
  ngOnInit(): void {
    if (!this.authnService.email || !this.authnService.password) {
      this.router.navigate(['auth/login']);
    }
    this.formGroup = this.fb.group({
      twoFactorCode: [null, Validators.minLength(6)],
      twoFactorRecoveryCode: [null, Validators.minLength(11)],
    });
  }
  async verify() {
    if (!this.formGroup.valid) {
      return;
    }
    try {
      this.resetApiMessage();
      this.setState('submit', true);
      this.setState('disabled', true);
      await this.authnService.login({
        accountAlias: await this.authnService.getAccountAlias(),
        email: this.authnService.email,
        password: this.authnService.password,
        ...this.formGroup.value,
      });
      await this.authnService.checkUserRole();
    } catch (errorResponse) {
      this.setApiMessage(errorResponse);
    }
    this.setState('submit', false);
    this.setState('disabled', false);
  }

  private _recoveryMode = false;
  set recoverMode(value: boolean) {
    this.resetApiMessage();
    if (value) {
      this.formGroup.get('twoFactorCode')?.disable();
      this.formGroup.get('twoFactorRecoveryCode')?.enable();
    } else {
      this.formGroup.get('twoFactorCode')?.enable();
      this.formGroup.get('twoFactorRecoveryCode')?.disable();
    }
    this._recoveryMode = value;
  }

  get recoverMode(): boolean {
    return this._recoveryMode;
  }

  ngAfterViewInit() {
    this.inputElement.nativeElement.focus();
  }
}
